import ModalBody from "../../component/modal/body/ModalBody";
import ModalHeader from "../../component/modal/header/ModalHeader";
import Modal from "../../component/modal/Modal";
import WalletAccountList from "../account/list/WalletAccountList";
import {AppStateAccountData} from "../account/accountTypes";
import peraWalletManager from "../../core/integrations/pera-wallet/PeraWalletManager";
import {
  useSelectedWalletAccounts,
  useSelectedWalletType,
  useWalletContextDispatch
} from "../util/context/WalletContext.utils";
import {AssetListItemData} from "../../asset/util/assetModels";

// scss import is moved here so the Modal and InfoText styles can be overridden without increasing the CSS selector specificity
import "./_select-account-modal.scss";

interface SelectAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function SelectAccountModal({isOpen, onClose}: SelectAccountModalProps) {
  const walletContextDispatch = useWalletContextDispatch();
  const walletAccounts = useSelectedWalletAccounts();
  const {isPeraWallet} = useSelectedWalletType();

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={"Select Account"}
      customClassName={"select-account-modal"}
      onClose={handleClose}>
      <ModalHeader
        title={"Select an account to continue"}
        customClassName={"has-space-between is-vertically-centered"}
      />

      <ModalBody customClassName={"select-account-modal__body"}>
        <WalletAccountList
          customClassName={"select-account-modal__account-list"}
          accounts={walletAccounts}
          onSelect={selectAccount}
        />
      </ModalBody>
    </Modal>
  );

  function handleClose() {
    if (isPeraWallet && peraWalletManager.isConnected) {
      peraWalletManager.disconnect();
    }

    onClose();
  }

  function selectAccount(
    account: {
      detail: AppStateAccountData;
      assets: AssetListItemData[];
    },
    setInWalletAccountsAsWell?: boolean
  ) {
    onClose();
    walletContextDispatch({
      type: "SET_ACCOUNT",
      account,
      setInWalletAccountsAsWell
    });
  }
}

export default SelectAccountModal;
